var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indentDetails"},[_c('logistics',{attrs:{"detailsData":_vm.detailsData}}),_c('receiving-info',{attrs:{"detailsData":_vm.detailsData}}),_c('supplier',{attrs:{"oederProductList":_vm.oederProductList}}),_c('indent-date',{attrs:{"detailsData":_vm.detailsData}}),_c('pay-bottom',{attrs:{"detailsData":_vm.detailsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }